export function dognetPurchase(
  accountId: string,
  campaignId: string,
  totalCost: string,
  orderId: string,
  productIds: string,
  coupon: string,
  currency: string,
  provision: string,
): void {
  if (
    typeof window !== 'undefined' &&
    window &&
    window.PostAffTracker &&
    accountId &&
    campaignId &&
    totalCost
  ) {
    window.PostAffTracker.setAccountId(accountId);
    const sale = window.PostAffTracker.createSale();
    sale.setCampaignID(campaignId);
    sale.setTotalCost(provision); // výška provízie
    sale.setData1(totalCost); // výšku objednávky BEZ DPH a BEZ DOPRAVY
    sale.setOrderID(orderId);
    sale.setProductID(productIds); // názvy alebo IDčka produktov
    sale.setCoupon(coupon); // kód zľavového kupónu
    sale.setCurrency(currency); // EUR, RON, HRK, HUF, PLN, CZK,..
    window.PostAffTracker.register();
  }
}
